// extracted by mini-css-extract-plugin
export var noMouseEvents = "SelectionClamp-module--noMouseEvents--172bc";